export enum Route {
    Main = '/',
    Login = '/login',
    LoginSso = '/login/sso',
    /**********************************/
    Model = '/models/:modelId',
    Group = '/groups/:groupId',
    User = '/users/:userId',
    Account = '/accounts/:accountId',
    Quote = '/quotes/:symbol',
    NewsArticle = '/articles/:provider/:articleId',
}

export enum AdvisorMenuRoute {
    Dashboard = '/',
    ServiceRequest = '/service-request',

    AccountsPositions = '/accounts/positions',
    AccountsValuation = '/accounts/valuation',
    AccountsGroups = '/accounts/groups',
    AccountsActivity = '/accounts/activity',
    AccountsRegister = '/accounts/register',

    ModelsCreateModel = '/models/create',
    ModelsManageModels = '/models/manage',
    ModelsModelMarketplace = '/models/model-marketplace',
    ModelsDriftReport = '/models/drift-report',

    TradingAccountOrModel = '/trading/account-or-model',
    TradingAllocation = '/trading/allocation',
    TradingPreAllocation = '/trading/pre-allocation',
    TradingTradeBlotter = '/trading/saved-orders',
    TradingPreIpoMarketplace = '/trading/pre-ipo-marketplace',

    AllocationNewAllocation = '/allocation/new',
    AllocationHistory = '/allocation/history',

    TransfersMoney = '/transfers/money',
    TransfersBankLinks = '/transfers/bank-links',
    TransfersAcats = '/transfers/acats',

    ClientsAllClients = '/clients/all',
    ClientsAddNewClient = '/clients/add',

    Insights = '/insights/home',
    InsightsEtfCenter = '/insights/etf-center',
    InsightsOptionRadar = '/insights/option-radar',
    InsightsIpo = '/insights/ipo-center',
    InsightsSectors = '/insights/sectors-industries',
    InsightsTableTopETF = '/insights/home/topetf',
    InsightsTableEarnings = '/insights/home/earnings',
    InsightsTableMostActive = '/insights/home/most-active',
    InsightsEarnings = '/insights/earnings',
    InsightsAnalystRatings = '/insights/analyst-ratings',
    InsightsScreener = '/insights/screeners',

    ReportsAumByAccount = '/reports/aum-by-account',
    ReportsAccountActivity = '/reports/account-activity',
    ReportsAccountHistory = '/reports/account-history',
    ReportsAumByAsset = '/reports/aum-by-asset',
    ReportsPositionsByAccount = '/reports/positions-by-account',
    ReportsTradeBlotter = '/reports/trade-blotter',
    ReportsTransactionFees = '/reports/transaction-fees',
    ReportsAdvisoryFees = '/reports/advisory-fees',
    ReportsBalanceSummaryReport = '/reports/balance-summary-report',
    ReportsMaturityDate = '/reports/maturity-date',
    ReportsClientList = '/reports/client-list',

    ToolsAlphatools = 'https://alphatools.ai/tools/dashboard',
    ToolsOnboarding = 'https://accounts-dev.orbisfn.io/login',

    DocumentsStatements = '/documents/statements',
    DocumentsConfirmations = '/documents/confirmations',
    DocumentsTaxDocuments = '/documents/tax-documents',

    SettingsAdvisors = '/settings/advisors',
    SettingsFirmSetup = '/settings/firm-setup',
    SettingsYourProfile = '/settings/your-profile',
    SettingsPlatformSettings = '/settings/platform',
    ContactSupport = '/support/contact',
    FormLibrary = '/support/form-library',

    ComponentsTable = '/components/table',
}

export enum ClientMenuRoute {
    Dashboard = '/',
    AccountSummary = '/account/summary',
    AccountHistory = '/account/history',
    Positions = '/positions',
    Activity = '/activity',
    AccountDocuments = '/account-documents',
    ClientDocuments = '/client-documents',
    Profile = '/settings/profile',
    SettingsPlatformSettings = '/settings/platform',
    SettingsYourProfile = '/settings/your-profile',

    Acats = '/transfers/acats',
    Money = '/transfers/money',
    BankLinks = '/transfers/bank-links',
}

export enum DashboardSummaryRoute {
    OptionsInTheMoney = '/dashboard/option-in-the-money',
    OptionsExpiringSoon = '/dashboard/options-expiring-soon',
    UnallocatedTrades = '/dashboard/unallocated-trades',
    VoluntaryOffers = '/dashboard/voluntary-offers',
    MandatoryOffers = '/dashboard/mandatory-offers',
    NeedAttention = '/dashboard/need-attention',
    Acats = '/dashboard/acats',
    MoneyMovements = '/dashboard/money-movements',
    Rmds = '/dashboard/rmds',
    DriftReport = '/dashboard/drift-report',
    MarginCalls = '/dashboard/margin-calls',
    CorporateActions = '/dashboard/corporate-actions',
    TradeBreaks = '/dashboard/trade-breaks',
    NewAccounts = '/dashboard/new-accounts',
    StockSplits = '/dashboard/stock-splits',
    WashSales = '/dashboard/wash-sales',
    Revised1099s = '/dashboard/revised-1099s',
    Earnings = '/dashboard/earnings',
    UpcomingDividends = '/dashboard/upcoming-dividends',
    LatestActivity = '/dashboard/latest-activity',
}
